// extracted by mini-css-extract-plugin
export default {"cellButtonWrapper":"cellButtonWrapper--cuMPq","inputCellButton":"inputCellButton--MQwn8","cellButton":"cellButton--qdUfc"};